"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HoodooEventHandlerScript = void 0;
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Ability_HoodooEventHandlerScript = class Ability_HoodooEventHandlerScript {
    run(sequence, container, handler, event) {
        const { casterId } = handler.args.scriptArgs;
        if (container.isDeceased(casterId)) {
            container.cancelEventHandler(handler.id);
            return;
        }
        else if (container.testAttribute(casterId, "Luck", 50)) {
            return;
        }
        container.applyAttackWithDamage({
            sequence,
            abilityKey: "Hoodoo",
            attackType: "magic",
            attackerId: casterId,
            targetId: event.subject,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus((0, Random_1.randomPercent)() <= 50 ? "Nature" : "Death", 50)
            ]
        });
    }
};
Ability_HoodooEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_Hoodoo")
], Ability_HoodooEventHandlerScript);
exports.Ability_HoodooEventHandlerScript = Ability_HoodooEventHandlerScript;
